export function resolveHasSizeData(data) {
  if (data && data.body && data.body.data) {
    return true;
  }
  if (data && data.garment && data.garment.data) {
    return true;
  }
  return false;
}
